var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sticker-setting-container" }, [
    _c("div", { staticClass: "sticker-item-view" }, [
      _c("div", { staticClass: "sticker-footer" }, [
        _c(
          "div",
          { staticClass: "sticker-sort-list" },
          _vm._l(_vm.stickerList, function (item) {
            return _c("button", {
              key: item.id,
              staticClass: "sticker-footer-item",
              class: { inactive: _vm.selectedSticker !== item.id },
              style: {
                "background-image":
                  "url(" +
                  _vm.cdnImgUrl(
                    item.imagePath?.replace(".svg", "_active.svg")
                  ) +
                  ")",
              },
              attrs: { value: item.id },
              on: { click: _vm.changeStickers },
            })
          }),
          0
        ),
        _c("div", { staticClass: "sticker-control-container" }, [
          _c("button", {
            staticClass: "reset-sticker",
            on: { click: _vm.resetStickerItem },
          }),
        ]),
      ]),
      _vm.selectedSticker
        ? _c(
            "ul",
            {
              staticClass: "sticker-item-list",
              class: { "device-coordi": _vm.isDevicetest },
            },
            _vm._l(_vm.stickerItems[_vm.selectedSticker], function (item) {
              return _c("li", {
                key: item.id,
                style: {
                  "background-image":
                    "url(" + _vm.cdnImgUrl(item.imagePath) + ")",
                },
                on: {
                  click: function ($event) {
                    return _vm.selectItem(item)
                  },
                },
              })
            }),
            0
          )
        : _c("div", { staticClass: "sticker-item-list" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-full sticker-none flex items-center justify-center text-white flex-col",
              },
              [
                _c("div", { staticClass: "none-message" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("camstudy.stopwatch.noItem")) + " "
                  ),
                ]),
                _c("button", { on: { click: _vm.onClickStickerPage } }, [
                  _vm._v("구매하기"),
                ]),
              ]
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }